import { useState } from "react";
import Dropzone from "react-dropzone";
import { Remove, Upload, UploadDownload } from "../../resources/assetsManager";

const FileDrop = ({
  passRawData,
  label,
  sampleFile,
  style,
  onClickDownloadSample,
}) => {
  const [fileName, setFileName] = useState("");
  //   const { enqueueSnackbar } = useSnackbar();
  const [showFileName, setShowFileName] = useState(false);
  const handleDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length <= 1) {
      setFileName(acceptedFiles.map((file) => file.name));
      setShowFileName(true);
      const reader = new FileReader();
      reader.onload = () => {
        if (acceptedFiles) {
          passRawData(acceptedFiles);
        }
      };

      reader.readAsBinaryString(acceptedFiles[0]);
    } else {
    }
  };

  return (
    <div style={{ width: "100%", ...style }}>
      <p
        style={{
          color: "black",
          fontSize: "14px",
          margin: "0px",
          marginBottom: "5px",
          marginLeft: "5px",
        }}
      >
        {label}
      </p>
      <div>
        <Dropzone onDrop={handleDrop} accept=".csv,">
          {({
            getRootProps,
            getInputProps,
            isDragActive,
            isDragAccept,
            isDragReject,
          }) => {
            const additionalClass = isDragAccept
              ? "accept"
              : isDragReject
              ? "reject"
              : "";

            return (
              <div
                style={{
                  height: 60,
                  borderWidth: "2px 2px 2px 2px",
                  borderStroke: "1px",
                  minWidth: 200,
                  maxWidth: 600,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: showFileName ? "flex-start" : "center",
                  flexDirection: "column",
                  backgroundColor: "#F3F3F3",
                  width: "100%",
                  borderRadius: "4px",
                }}
                {...getRootProps({
                  className: `dropzone ${additionalClass}`,
                })}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: showFileName ? "flex-start" : "center",
                  }}
                >
                  {showFileName ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0px 20px",
                        width: "100%",
                      }}
                    >
                      <p
                        style={{ color: "#5C5C5C", padding: 0, margin: 6 }}
                        className="roboto"
                      >
                        {fileName}
                      </p>
                      <img
                        src={Remove}
                        alt="Remove"
                        style={{
                          width: "13px",
                          height: "13px",
                          cursor: "pointer",
                          zIndex: "2",
                        }}
                        onClick={() => {
                          setFileName(fileName.filter((ele) => ele.name));
                          setShowFileName(false);
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img src={Upload} alt="Upload" />
                      <span
                        style={{
                          color: "#5C5C5C",
                          fontSize: "15px",
                          marginLeft: 5,
                          fontWeight: "500",
                        }}
                        className="roboto"
                      >
                        Click here to Upload File
                      </span>
                    </div>
                  )}
                </div>
              </div>
            );
          }}
        </Dropzone>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "5px",
        }}
        onClick={() => {
          // onClickDownloadSample();
        }}
      >
        <img src={UploadDownload} alt="Download" />
        <span
          style={{
            color: "#5C5C5C",
            fontSize: "12px",
            marginLeft: 5,
            fontWeight: "500",
          }}
          className="roboto"
        >
          Download Sample File
        </span>
      </div>
    </div>
  );
};

export default FileDrop;
